// Types
import {UserReducerType} from '../../../types/UserTypes';
import {userTypes} from '../types';

const initialState = {
  userResponse: {
    count: 0,
    rows: []
  },
  params: {
    roleTypes: [],
  }
}

const userReducer = (state = initialState, action: UserReducerType) => {
  switch (action.type) {
    case userTypes.GET_USER_PARAMS:
      return {
        ...state,
        params: action.params
      };
    case userTypes.GET_ALL_USERS:
      return {
        ...state,
        userResponse: action.userResponse
      };
    default:
      return state;
  }
};

export default userReducer;
